import React, { useCallback } from "react";
import PropTypes from "prop-types";
import ButtonTertiary from "~components/molecules/button/button_tertiary/button_tertiary";
import useAccordionTransitions from "~hooks/use_accordion_transitions/use_accordion_transitions";
import RscHbNavLink from "../rsc_hb_nav_link/rsc_hb_nav_link";
import {
  contentStyle,
  itemWrapperStyle,
  subMenuStyle,
} from "./rsc_hb_nav_expanding_menu_category.module.scss";

export default function RscHbNavExpandingMenuCategory({
  index,
  title,
  items,
  isActive,
  onClick,
  activeItem,
}) {
  const ref = useAccordionTransitions(isActive);

  const handleButtonClick = useCallback(() => {
    return isActive ? onClick(null) : onClick(index);
  }, [index, isActive, onClick]);

  return (
    <>
      <ButtonTertiary
        title={title}
        onClick={handleButtonClick}
        trailingIcon="icon_chevron_down"
        isActive={isActive}
        isFontRegular
        spaceBetween
      />

      <div className={contentStyle} ref={ref}>
        <div className={subMenuStyle}>
          {items &&
            items.map((item) => {
              return (
                <div key={item.title} className={itemWrapperStyle}>
                  <RscHbNavLink
                    {...item}
                    isFontRegular
                    isActive={item.slug === activeItem}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

RscHbNavExpandingMenuCategory.defaultProps = {
  activeItem: "",
  isActive: false,
  items: [],
  onClick: () => {},
  title: null,
};

RscHbNavExpandingMenuCategory.propTypes = {
  activeItem: PropTypes.string,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onClick: PropTypes.func,
  title: PropTypes.string,
};
